import { ReactElement, useState } from 'react';
import { PlaceType } from 'components/UI/NewLocationAutocomplete';
import CTA from 'components/UI/Cta';
import { IComponentCtaSectionFields, IPageLocationFields } from 'types/contentful';
import RichText from 'components/UI/Richtext';
import { LINK_CONTENT_TYPE } from 'lib/consts';
import IFrameCTA from 'components/UI/IFrameCta';

export interface CTASectionProps extends IComponentCtaSectionFields {
  locations?: IPageLocationFields[];
  initValue?: PlaceType | null;
  freshPaintToken: string | null | undefined;
  className?: string;
  subHeading?: string | undefined;
}

export default function CTASection({
  className,
  description,
  ctas,
  title,
}: CTASectionProps): ReactElement {
  const [background] = useState<string>('bg-muted');

  return (
    <div
      className={`px-site-component py-10 md:py-20 text-primary-actual ${className} ${background}`}
    >
      <div className="mx-auto">
        <div className="mx-auto grid gap-8 lg:grid-cols-2 lg:gap-12 lg:gap-16">
          <div className="relative">
            <h5 className="bordered-heading bh-cta-section font-heading text-new-34 lg:text-4xl lg:leading-new-43 mb-0">
              {title}
            </h5>
          </div>

          <div className="">
            {description && (
              <RichText
                document={description}
                classNames="text-left font-light wysiwyg-richtext text-lg"
              />
            )}

            {!!ctas?.length && (
              <div className="flex flex-col items-start space-y-5 md:flex-row md:flex-wrap md:items-center md:space-y-0 md:gap-5 mt-8">
                {ctas.map((cta, index) => (
                  <div key={cta.sys?.id ?? index}>
                    {cta.sys.contentType.sys.id === LINK_CONTENT_TYPE.fragmentIFrameCta ? (
                      <IFrameCTA
                        {...cta.fields}
                        backgroundColor="black"
                        classNames="w-full md:w-auto"
                      />
                    ) : (
                      <CTA
                        {...cta.fields}
                        classNames="text-primary-actual button-text bg-white w-full md:w-auto"
                      />
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
